// extracted by mini-css-extract-plugin
export default {"container":"LandAbout_container__Sh-M4","aboutImage":"LandAbout_aboutImage__pqGIG","aboutText":"LandAbout_aboutText__uIOku"};